import { IProsecutorOrganizations } from 'APIPackage/CatalogsModule/interfaces/IProsecutorOrganizations';

import { IProsecutorOrganizationsSelectOption } from '../interfaces/IProsecutorOrganizationsSelectOption';

export const createProsecutorOrganizationsSelectOption = (
  prosecutorOrganization: IProsecutorOrganizations,
): IProsecutorOrganizationsSelectOption => ({
  ...prosecutorOrganization,
  label: prosecutorOrganization.title,
  value: prosecutorOrganization.id,
});
